<template>
  <svg
    width="17"
    height="13"
    viewBox="0 0 17 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5242 1.59244L14.0235 11.7756C13.8348 12.4943 13.3428 12.6732 12.6436 12.3346L8.83335 9.9102L6.99479 11.437C6.79133 11.6127 6.62116 11.7597 6.22903 11.7597L6.50278 8.40892L13.5648 2.89888C13.8718 2.66251 13.4982 2.53154 13.0876 2.76792L4.35718 7.51453L0.598684 6.49877C-0.218863 6.27837 -0.233661 5.79285 0.768852 5.45426L15.4699 0.563904C16.1506 0.343502 16.7462 0.694867 16.5242 1.59244Z"
      fill=""
    />
  </svg>
</template>
